var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30.051,
    viewBox: "0 0 30 30.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2af598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009efd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_pencil",
    d: "M30,4.691a4.7,4.7,0,0,0-8.023-3.315L3.066,20.363a5.628,5.628,0,0,0-1.358,2.2l-.018.054L0,30.05l7.453-1.669.055-.018A5.637,5.637,0,0,0,9.712,27L28.626,8.015A4.667,4.667,0,0,0,30,4.691ZM4.133,26.721l-.79-.791.571-2.51,2.736,2.737ZM26.965,6.358,8.6,24.794,5.278,21.467,17.856,8.838l1.915,1.915L21.43,9.095,19.511,7.176,21.3,5.385l1.922,1.922,1.659-1.659L22.951,3.723l.687-.69a2.352,2.352,0,1,1,3.327,3.325ZM12.341,27.679H30v2.346H10Zm0,0",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.43bcc513d64268936558f1448e68f0c9.svg";
export { ForwardRef as ReactComponent };